export const getInternationalPhoneDigits = (phone) => {
    const digits = String(phone || '').replace(/\D/g, '');

    if (!digits) return '';
    if (digits.length === 9 && digits.startsWith('5')) return `995${digits}`;

    return digits;
};

export const getTelHref = (phone) => {
    const digits = getInternationalPhoneDigits(phone);
    return digits ? `tel:+${digits}` : null;
};

export const getWhatsappHref = (phone, text) => {
    const digits = getInternationalPhoneDigits(phone);
    if (digits.length < 9) return null;
    const message = String(text || '').trim();
    return message
        ? `https://wa.me/${digits}?text=${encodeURIComponent(message)}`
        : `https://wa.me/${digits}`;
};

export const getViberHref = (phone) => {
    const digits = getInternationalPhoneDigits(phone);
    return digits.length >= 9
        ? `viber://chat?number=${encodeURIComponent(`+${digits}`)}`
        : null;
};

export const getViberShareHref = (text) => {
    const value = String(text || '').trim();
    return value
        ? `viber://forward?text=${encodeURIComponent(value)}`
        : 'viber://forward';
};

export const getMailtoHref = (email) => {
    const value = String(email || '').trim();
    return value && value.includes('@') ? `mailto:${value}` : null;
};

export const getTelegramHref = (usernameOrUrl) => {
    const value = String(usernameOrUrl || '').trim();
    if (!value) return null;

    const username = value
        .replace(/^@/, '')
        .replace(/^https?:\/\/(www\.)?(t\.me|telegram\.me)\//i, '')
        .split(/[/?#]/)[0];

    if (!/^[a-zA-Z0-9_]{5,32}$/.test(username)) return null;

    return `https://t.me/${username}`;
};

export const getInstagramHref = (usernameOrUrl) => {
    const value = String(usernameOrUrl || '').trim();
    if (!value) return null;

    const username = value
        .replace(/^@/, '')
        .replace(/^(https?:\/\/)?(www\.)?instagram\.com\//i, '')
        .split(/[/?#]/)[0];

    if (!/^[a-zA-Z0-9_.]{1,30}$/.test(username)) return null;

    return `https://instagram.com/${username}`;
};

const FACEBOOK_URL_RE =
    /^(https?:\/\/)?(www\.|m\.|web\.)?(facebook\.com|fb\.com|fb\.me)\/\S+$/i;

export const getFacebookHref = (url) => {
    const value = String(url || '').trim();
    if (!FACEBOOK_URL_RE.test(value)) return null;
    return /^https?:\/\//i.test(value) ? value : `https://${value}`;
};
